var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "a-list",
        {
          attrs: {
            "item-layout": "horizontal",
            "data-source": _vm.conversations,
            loading: _vm.loading
          }
        },
        _vm._l(_vm.conversations, function(item, index) {
          return _c(
            "a-list-item",
            { key: item.id },
            [
              _c("a-list-item-meta", {
                attrs: { description: item.introduction },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "title",
                      fn: function() {
                        return [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "margin-right": "10px",
                                color: "#999"
                              }
                            },
                            [_vm._v(_vm._s(index + 1))]
                          ),
                          _c(
                            "a",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.viewConversation(item.id)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(item.name) +
                                  "\n            "
                              )
                            ]
                          )
                        ]
                      },
                      proxy: true
                    }
                  ],
                  null,
                  true
                )
              }),
              _c("div", [_vm._v(_vm._s(_vm.formatDate(item.updated_at)))])
            ],
            1
          )
        }),
        1
      ),
      _c(
        "div",
        { staticStyle: { "text-align": "center", "margin-top": "20px" } },
        [
          _vm.hasMore && _vm.conversations.length > 0
            ? _c(
                "a-button",
                {
                  attrs: { loading: _vm.loading, type: "primary" },
                  on: { click: _vm.loadMore }
                },
                [_vm._v("\n        加载更多\n      ")]
              )
            : _vm._e(),
          !_vm.hasMore && _vm.conversations.length > 0
            ? _c("div", { staticStyle: { color: "#999" } }, [
                _vm._v("\n        没有更多数据了\n      ")
              ])
            : _vm._e()
        ],
        1
      ),
      _c(
        "div",
        {
          staticStyle: {
            display: "flex",
            "justify-content": "space-between",
            "align-items": "center",
            "margin-top": "10px"
          }
        },
        [
          _c(
            "div",
            [
              _c("span", [_vm._v("每页显示：")]),
              _c(
                "a-select",
                {
                  staticStyle: { width: "80px" },
                  attrs: { value: _vm.pageSize, size: "small" },
                  on: { change: _vm.handlePageSizeChange }
                },
                _vm._l(_vm.pageSizeOptions, function(size) {
                  return _c(
                    "a-select-option",
                    { key: size, attrs: { value: size } },
                    [_vm._v("\n            " + _vm._s(size) + "\n          ")]
                  )
                }),
                1
              )
            ],
            1
          ),
          _c("div", { staticStyle: { color: "#666" } }, [
            _vm._v(
              "\n        共 " +
                _vm._s(_vm.conversations.length) +
                " 条记录\n      "
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }